// extracted by mini-css-extract-plugin
export var grayedOut = "RadioHtmlOption_grayedOut__2tcm0";
export var md = "768px";
export var radioHtmlOptionWrapper = "RadioHtmlOption_radioHtmlOptionWrapper__e1xVf";
export var radioInput = "RadioHtmlOption_radioInput__BBgMn";
export var shared = "'../../../shared.module.css'";